import queryString from 'query-string';

export const isDataStreamLayer = (layer) => (
  layer.type === 'DATA_STREAM_CATEGORY'
  || layer.type === 'DATA_STREAM_RANGE'
  || layer.type === 'DATA_STREAM_CATEGORY_RANGE'
);

export const makeTileSource = ({
  geom, dataKey, layer, filters, tileSourceOptions, queryOverride, forceDots, querystring = '',
}) => {
  let dataStreamQuery = {};
  if (isDataStreamLayer(layer)) {
    dataStreamQuery = {
      with_data_point: layer.dataStreamField,
    };
  }
  const tileSource = { ...tileSourceOptions };
  const layerFilter = layer.filterString;

  const query = {
    geom: forceDots ? 'geom_pt' : geom,
    props: dataKey,
    ...dataStreamQuery,
    ...queryOverride,
  };
  if (layer.source) {
    query.source = layer.source;
  }

  const url = tileSource.tiles[0];

  const filterString = layer.isNew || typeof layer.filters === 'string' ? layer.filters : filters;

  if (query && query.props) {
    // eslint-disable-next-line prefer-destructuring
    query.props = query.props.split('+')[0];
  }

  const tileURL = `${url}?${
    queryString.stringify(query)
  }${
    layer.preventFiltering || !filterString ? '' : `&${filterString}`
  }${
    layerFilter ? `&${layerFilter}` : ''
  }${
    querystring ? `&${querystring}` : ''
  }`;

  tileSource.tiles = [
    tileURL,
  ];

  return tileSource;
};
